import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { VpButton, VpInfoMenu } from '@vp-ui';

export const NavItems = withRouter(({ items, history }) => {
  const currentRoute = window.location.pathname;

  return items?.map((item) =>
    item.subpages ? (
      <VpInfoMenu
        key={item?.url}
        menuItems={item.subpages}
        optionalLabelValue="text"
        onSelect={(item) => {
          history.push(item.url);
        }}
        menuButton={
          <VpButton
            key={item?.url}
            variant="navitem"
            current={
              item?.subpages.find((subpage) => currentRoute.includes(subpage.url))
                ? currentRoute
                : undefined
            }
          >
            {item.text}
          </VpButton>
        }
      />
    ) : (
      <VpButton
        key={item?.url}
        to={item?.url}
        variant="navitem"
        current={currentRoute.includes(item?.url) ? currentRoute : undefined}
      >
        {item.text}
      </VpButton>
    )
  );
});

NavItems.propTypes = {
  items: PropTypes.array,
};

export default NavItems;



// WEBPACK FOOTER //
// ./src/vp-ui/components/NavItems/NavItems.jsx